import { Stack } from "@certn/cascadia";
import { Illustration, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import type { DbsVariant } from "./DBSConsent";

export function SkipDbsConsent({
  clientName,
  variant = "basic",
}: {
  clientName?: string;
  variant?: DbsVariant;
}) {
  const { t } = useTranslation();

  const messageByVariant: Record<DbsVariant, string> = {
    enhanced: t(
      "We acknowledge your decision to opt out of Enhanced DBS consent. An enhanced criminal record check will not be submitted to the DBS. {{clientName}} will contact you to agree next steps. In the meantime, please complete the rest of this application.",
      { clientName }
    ),
    standard: t(
      "We acknowledge your decision to opt out of Standard DBS consent. A standard criminal record check will not be submitted to the DBS. {{clientName}} will contact you to agree next steps. In the meantime, please complete the rest of this application.",
      { clientName }
    ),
    basic: t(
      "We acknowledge your decision to opt out of DBS consent. A criminal record check will not be submitted to the DBS. {{clientName}} will contact you to agree next steps. In the meantime, please complete the rest of this application.",
      { clientName }
    ),
  };
  const message = messageByVariant[variant];

  return (
    <>
      <Text style="form/body-primary">{message}</Text>
      <Stack orientation="horizontal" justify="center">
        <Illustration size={200} name="messages" />
      </Stack>
    </>
  );
}
